import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={"100%"}
      height={110}
      viewBox="0 0 111.124 141.418"
      {...props}
    >
      <g data-name="Component 20 \u2013 1">
        <path
          data-name="Path 7429"
          d="M51.773 42.147a14.975 14.975 0 0022.3-15.44h.008L71.4 8.051l-16.136 6.484z"
          fill="#a0d468"
        />
        <path
          data-name="Path 7430"
          d="M25.26 35.142A17.894 17.894 0 1047.142 9.501L26.309 1.045l-3.193 22.22.009-.005a17.743 17.743 0 002.135 11.882z"
          fill="#609c20"
        />
        <path
          data-name="Path 7431"
          d="M75.119 26.657c0-.032 0-.064-.009-.1L72.43 7.905a1.045 1.045 0 00-1.424-.821l-12.341 4.961a1.045 1.045 0 10.78 1.939l11.1-4.464 2.474 17.215a1.048 1.048 0 00.014.146 13.94 13.94 0 01-20.738 14.36c-.022-.013-.045-.024-.068-.035a18.93 18.93 0 001.954-1.708l12.232-3.278a1.045 1.045 0 00-.541-2.019l-9.412 2.523a18.923 18.923 0 002.4-5.051l8.4-2.25a1.045 1.045 0 00-.541-2.019l-6.189 1.657 2.323-4.024 4.91-1.316a1.045 1.045 0 00-.541-2.019l-2.891.775 2.223-3.851a1.045 1.045 0 00-1.81-1.045l-2.214 3.851-.775-2.891a1.045 1.045 0 10-2.019.541l1.316 4.91-1.364 2.354A18.87 18.87 0 0047.555 8.54l-.02-.008-4.728-1.919a1.045 1.045 0 00-.786 1.936l4.685 1.9.065.027a16.8 16.8 0 013.273 29.715l-1.754-3.036 3.8-14.188a1.045 1.045 0 10-2.019-.541l-3.258 12.17-3.868-6.7 2.637-9.843a1.045 1.045 0 10-2.019-.541l-2.1 7.824-3.049-5.282 1.588-5.928a1.045 1.045 0 10-2.019-.541l-1.043 3.91-2.889-5a1.045 1.045 0 10-1.81 1.045l2.889 5-3.909-1.047a1.045 1.045 0 00-.541 2.019l5.927 1.588 3.049 5.282-7.826-2.097a1.045 1.045 0 00-.541 2.019l9.842 2.637 3.868 6.7-12.169-3.26a1.045 1.045 0 00-.541 2.019l14.188 3.8 1.753 3.038a16.787 16.787 0 01-24.08-17.8 1.014 1.014 0 00.014-.155l2.989-20.768 6.922 2.809a1.045 1.045 0 00.786-1.936L26.702.076a1.045 1.045 0 00-1.427.82l-3.194 22.22a1.034 1.034 0 00-.01.106A18.9 18.9 0 0049.28 43.049l1.284 2.224a1.045 1.045 0 101.81-1.045l-.476-.825a15.973 15.973 0 007.375 1.812 16.153 16.153 0 004.163-.548 16 16 0 0011.683-18.01z"
          fill="#fff"
        />
        <path
          data-name="Path 7432"
          d="M38.357 6.98a1.045 1.045 0 10-.739-.306 1.053 1.053 0 00.739.306z"
          fill="#fff"
        />
        <path
          data-name="Path 7433"
          d="M66.515 15.597a1.045 1.045 0 001.691-1.228l-.006-.009a1.045 1.045 0 00-1.691 1.228z"
          fill="#fff"
        />
        <g stroke="#fff" strokeWidth={2}>
          <path
            data-name="Path 7427"
            d="M110.124 84.72a5.685 5.685 0 01-5.684 5.683h-7.956L55.562 50.618 14.641 90.403H6.684a5.69 5.69 0 01-4-9.73L53.2 32.249a3.405 3.405 0 014.729 0L108.4 80.627a5.679 5.679 0 011.728 4.093zm0 0"
            fill="#609c20"
          />
          <path
            data-name="Path 7428"
            d="M55.563 50.618L14.641 90.402v40.921a9.12 9.12 0 009.094 9.094H87.39a9.12 9.12 0 009.094-9.094V90.402zm0 0"
            fill="#b8d98a"
          />
        </g>
        <g data-name="light-bulb (6)" fill="#fff">
          <g data-name="Group 327">
            <path
              data-name="Path 7444"
              d="M49.457 126.118a2.05 2.05 0 002.048 2.05h8.202a2.05 2.05 0 100-4.1h-8.2a2.05 2.05 0 00-2.05 2.05z"
            />
            <path
              data-name="Path 7445"
              d="M49.457 122.017a2.05 2.05 0 002.048 2.05h8.202a2.05 2.05 0 100-4.1h-8.2a2.05 2.05 0 00-2.05 2.05z"
            />
            <path
              data-name="Path 7446"
              d="M61.757 117.916v-2.05h-12.3v2.05a2.05 2.05 0 002.048 2.05h8.202a2.051 2.051 0 002.05-2.05z"
            />
          </g>
          <g data-name="Group 328">
            <path
              data-name="Path 7447"
              d="M55.607 132.269a4.1 4.1 0 004.1-4.1h-8.2a4.1 4.1 0 004.1 4.1z"
            />
            <path
              data-name="Path 7448"
              d="M63.808 113.815v-2.4a4.075 4.075 0 011.547-3.143 15.379 15.379 0 10-19.419.064 4.088 4.088 0 011.468 3.193v2.286a2.057 2.057 0 002.051 2.05h12.303a2.057 2.057 0 002.05-2.05z"
            />
          </g>
          <g data-name="Group 329">
            <path
              data-name="Path 7449"
              d="M45.291 109.135a3.075 3.075 0 011.088 2.395v2.285a3.075 3.075 0 002.05 2.887v1.214a3.062 3.062 0 00.8 2.05 3.029 3.029 0 000 4.1 3.046 3.046 0 001.332 4.965 5.11 5.11 0 0010.078 0 3.045 3.045 0 001.343-4.964 3.028 3.028 0 000-4.1 3.062 3.062 0 00.8-2.05v-1.214a3.075 3.075 0 002.05-2.887v-2.4a3.056 3.056 0 011.169-2.35 16.4 16.4 0 00-10.385-29.083c-.268 0-.537.006-.807.019a16.593 16.593 0 00-15.608 16.282 16.31 16.31 0 006.09 12.851zm15.441 8.781a1.026 1.026 0 01-1.025 1.025h-8.2a1.026 1.026 0 01-1.025-1.025v-1.021h10.25zm0 4.1a1.026 1.026 0 01-1.025 1.025h-8.2a1.025 1.025 0 110-2.05h8.2a1.025 1.025 0 011.025 1.026zm-5.131 9.228a3.082 3.082 0 01-2.9-2.049h5.8a3.084 3.084 0 01-2.9 2.049zm4.1-4.1h-8.2a1.025 1.025 0 110-2.05h8.2a1.025 1.025 0 010 2.05zm-4.8-45.092a14.348 14.348 0 019.8 25.424 5.1 5.1 0 00-1.922 3.935v2.4a1.026 1.026 0 01-1.025 1.025h-12.3a1.026 1.026 0 01-1.025-1.025v-2.285a5.086 5.086 0 00-1.845-3.991 14.267 14.267 0 01-5.332-11.24 14.517 14.517 0 0113.654-14.244z"
            />
            <path
              data-name="Path 7450"
              d="M55.606 71.781a1.026 1.026 0 011.025 1.025v4.1a1.025 1.025 0 11-2.05 0v-4.1a1.025 1.025 0 011.025-1.025z"
            />
            <path
              data-name="Path 7451"
              d="M67.396 74.941a1.025 1.025 0 01.887 1.538l-2.051 3.55a1.026 1.026 0 01-1.783-1.014.042.042 0 01.007-.011l2.05-3.55a1.022 1.022 0 01.89-.513z"
            />
            <path
              data-name="Path 7452"
              d="M76.025 83.576a1.025 1.025 0 01.512 1.909l-3.55 2.05a1.025 1.025 0 11-1.037-1.768l.012-.007 3.551-2.051a1.016 1.016 0 01.512-.133z"
            />
            <path
              data-name="Path 7453"
              d="M75.085 95.361h4.1a1.025 1.025 0 110 2.05h-4.1a1.025 1.025 0 110-2.05z"
            />
            <path
              data-name="Path 7454"
              d="M72.476 105.106a1.023 1.023 0 01.513.137l3.55 2.046a1.026 1.026 0 11-1.014 1.783.042.042 0 01-.011-.007l-3.55-2.05a1.025 1.025 0 01.512-1.909z"
            />
            <path
              data-name="Path 7455"
              d="M38.735 105.105a1.025 1.025 0 01.512 1.909l-3.55 2.05a1.025 1.025 0 11-1.037-1.768.042.042 0 00.011-.007l3.551-2.051a1.022 1.022 0 01.513-.133z"
            />
            <path
              data-name="Path 7456"
              d="M32.026 95.361h4.1a1.025 1.025 0 110 2.05h-4.1a1.025 1.025 0 010-2.05z"
            />
            <path
              data-name="Path 7457"
              d="M35.186 83.576a1.023 1.023 0 01.513.137l3.55 2.046a1.026 1.026 0 01-1.014 1.783l-.012-.007-3.555-2.051a1.025 1.025 0 01.518-1.908z"
            />
            <path
              data-name="Path 7458"
              d="M43.816 74.94a1.025 1.025 0 01.889.513l2.05 3.551a1.025 1.025 0 11-1.768 1.036l-.007-.012-2.05-3.55a1.024 1.024 0 01.886-1.538z"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
